module.exports = __webpack_public_path__ + "static/img/head_20260827.6d9b8303.jpg";